var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01786 0C4.46317 0 4.82143 0.356667 4.82143 0.8V2.13333H10.1786V0.8C10.1786 0.356667 10.5368 0 10.9821 0C11.4275 0 11.7857 0.356667 11.7857 0.8V2.13333H12.8571C14.0391 2.13333 15 3.09 15 4.26667V13.8667C15 15.0433 14.0391 16 12.8571 16H2.14286C0.960938 16 0 15.0433 0 13.8667V4.26667C0 3.09 0.960938 2.13333 2.14286 2.13333H3.21429V0.8C3.21429 0.356667 3.57254 0 4.01786 0ZM4.01786 3.73333H2.14286C1.84821 3.73333 1.60714 3.97333 1.60714 4.26667V5.86667H13.3929V4.26667C13.3929 3.97333 13.1518 3.73333 12.8571 3.73333H4.01786ZM1.60714 7.46667V13.8667C1.60714 14.16 1.84821 14.4 2.14286 14.4H12.8571C13.1518 14.4 13.3929 14.16 13.3929 13.8667V7.46667H1.60714Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.2870fe810b44a0ecc386e15012a0693a.svg";
export { ForwardRef as ReactComponent };